import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FiSave } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import "react-toastify/dist/ReactToastify.css";

const DefinitionEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, fallback = "") => translations[key] || fallback;

  const [definition, setDefinition] = useState({ keyword: "", redirect_url: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDefinition = async () => {
      try {
        const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/definitions/${id}`);
        setDefinition(resp.data);
      } catch (error) {
        toast.error(getText("ERROR_FETCH_DEFINITION"));
      } finally {
        setLoading(false);
      }
    };

    fetchDefinition();
  }, [id]);

  const handleChange = (e) => {
    setDefinition({ ...definition, redirect_url: e.target.value });
  };

  const updateDefinition = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/definitions/${id}`, {
        redirect_url: definition.redirect_url,
      });

      toast.success(getText("SUCCESS_DEFINITION_UPDATED"));

    } catch (error) {
      console.error(error);
      toast.error(getText("ERROR_UPDATE_FAILED"));
    }
  };

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="card card-body">
        <h4 className="fw-bold text-primary mb-3">
          {getText("LABEL_EDIT_DEFINITION")}
        </h4>

        {loading ? (
          <div>{getText("LOADING", "Yükleniyor...")}</div>
        ) : (
          <>
            <div className="mb-3">
              <label className="form-label fw-bold">{getText("TABLE_KEYWORD_LABEL")}</label>
              <input className="form-control" value={definition.keyword} disabled />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">{getText("TABLE_REDIRECT_LABEL")}</label>
              <input
                className="form-control"
                value={definition.redirect_url}
                onChange={handleChange}
              />
            </div>

            <div className="d-flex justify-content-center">
              <button className="btn btn-primary" onClick={updateDefinition}>
                <FiSave /> {getText("SAVE_BTN")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DefinitionEdit;
